import { IMinerProfile } from "./reducer";

export enum ActionMinerProfiles {
  SET_PROFILES = "SET_PROFILES",
  DELETE_PROFILE = "DELETE_PROFILE",
  EDIT_PROFILES = "EDIT_PROFILES",
  ADD_PROFILE = "ADD_PROFILE",
}

export interface ActionMinerProfileBase {
  readonly type: ActionMinerProfiles;
  readonly payload?: any;
}

export interface ActionSetMinerProfiles extends ActionMinerProfileBase {
  payload: {
    Total: number;
    profiles: IMinerProfile[];
  };
}

export interface ActionDeleteMinerProfile extends ActionMinerProfileBase {
  payload: IMinerProfile["id"];
}

export interface ActionEditMinerProfile extends ActionMinerProfileBase {
  payload: IMinerProfile;
}

export interface ActionAddMinerProfile extends ActionMinerProfileBase {
  payload: IMinerProfile;
}
